import { Router } from '@angular/router';

/**
 * Builds the page path that is sent to Google Analytics.
 *
 * The matched route pattern is used instead of the real URL, so that
 *   /drivers/12457/Ion%20Popescu
 * becomes
 *   /drivers/:driverinfoFromLink/:driverNameFromLink
 *
 * This keeps GA4 from creating one row per driver / vehicle / device, and keeps
 * personal data (driver names, card numbers, registration numbers, IMEIs,
 * activation tokens) out of Google Analytics.
 */

const WILDCARD = '**';

/**
 * Returns the matched route template for the current navigation, e.g. `/drivers/:driverinfoFromLink`.
 * Returns an empty string when the router state cannot provide a usable template.
 */
export const getMatchedRouteTemplate = (router: Router): string => {
    const segments: string[] = [];
    let route = router.routerState.snapshot.root;

    while (route) {
        const path = route.routeConfig?.path;

        if (path === WILDCARD) {
            return '';
        }

        if (path) {
            segments.push(path);
        }

        route = route.firstChild;
    }

    return segments.length ? `/${segments.join('/')}` : '';
};

/**
 * Fallback used when the router state cannot provide a template.
 * Only long purely numeric segments are replaced, so short static routes such as
 * `/sessions/404`, `/app/2` or `/report/t2updatebilling` stay untouched.
 */
export const normalizeAnalyticsPath = (pathname: string): string => {
    const path = (pathname || '/').split('?')[0].split('#')[0];

    return path.replace(/\/\d{4,}(?=\/|$)/g, '/:id') || '/';
};
